// Mock data for OrvDigital

export const featuredProduct = {
  id: 'premium-lifestyle-content-collection',
  name: 'Premium Lifestyle Content Collection',
  slug: 'premium-lifestyle-content-collection',
  category: 'Creator Resources',
  shortDescription: 'High-quality luxury lifestyle content for creators and brands.',
  fullDescription: 'An exclusive collection of premium lifestyle content featuring luxury cars, supercars, yachts, private jets, luxury homes, hotels, travel destinations, business lifestyle and motivational aesthetic content. Perfect for content creators, social media managers, and digital marketers.',
  price: 'Coming Soon',
  originalPrice: null,
  images: [
    'https://images.unsplash.com/photo-1563291074-2bf8677ac0e5?w=800&q=80',
    'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80',
    'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80'
  ],
  features: [
    'Premium luxury car footage',
    'Supercars and exotic vehicles',
    'Luxury yachts and marine lifestyle',
    'Private jets and aviation',
    'High-end hotels and resorts',
    'Luxury homes and architecture',
    'Travel and destination content',
    'Business lifestyle imagery',
    'Motivational and aesthetic content'
  ],
  whatsIncluded: [
    'High-resolution video content',
    'Multiple formats optimized for social media',
    'Commercial usage rights',
    'Instant digital access',
    'Lifetime access to content'
  ],
  targetAudience: 'Content creators, social media managers, digital marketers, luxury brands, entrepreneurs, and online businesses.',
  isFeatured: true,
  isNew: true,
  externalCheckoutUrl: '#',
  seoTitle: 'Premium Lifestyle Content Collection | OrvDigital',
  seoDescription: 'Exclusive luxury lifestyle content collection for creators and brands.'
};

export const categories = [
  {
    id: 'ai-bundles',
    name: 'AI & Digital Bundles',
    slug: 'ai-digital-bundles',
    description: 'Practical AI resources, prompts and digital tools to streamline your workflow.',
    icon: 'Sparkles'
  },
  {
    id: 'templates',
    name: 'Templates',
    slug: 'templates',
    description: 'Ready-to-use templates and design assets that save time.',
    icon: 'Layout'
  },
  {
    id: 'creator-resources',
    name: 'Creator Resources',
    slug: 'creator-resources',
    description: 'Content, guides and tools for modern digital creators.',
    icon: 'Video'
  },
  {
    id: 'content-collections',
    name: 'Content Collections',
    slug: 'content-collections',
    description: 'Curated premium content collections for various niches.',
    icon: 'Layers'
  },
  {
    id: 'guides-ebooks',
    name: 'Guides & E-books',
    slug: 'guides-ebooks',
    description: 'Practical digital guides and comprehensive e-books.',
    icon: 'BookOpen'
  },
  {
    id: 'courses',
    name: 'Courses',
    slug: 'courses',
    description: 'Step-by-step online courses for skill development.',
    icon: 'GraduationCap'
  },
  {
    id: 'productivity',
    name: 'Productivity',
    slug: 'productivity',
    description: 'Tools and resources to boost productivity and efficiency.',
    icon: 'Zap'
  },
  {
    id: 'business-marketing',
    name: 'Business & Marketing',
    slug: 'business-marketing',
    description: 'Resources for entrepreneurs and growing businesses.',
    icon: 'TrendingUp'
  },
  {
    id: 'design-resources',
    name: 'Design Resources',
    slug: 'design-resources',
    description: 'Design assets and resources for creative projects.',
    icon: 'Palette'
  }
];

export const whyOrvDigital = [
  {
    number: '01',
    title: 'Premium Digital Products',
    description: 'Carefully selected resources designed for modern creators and online businesses.'
  },
  {
    number: '02',
    title: 'AI-Powered Resources',
    description: 'Practical AI resources, prompts and guides that help simplify your digital workflow.'
  },
  {
    number: '03',
    title: 'Ready-to-Use Templates',
    description: 'Useful templates and assets that save time and help you start faster.'
  },
  {
    number: '04',
    title: 'Creator Resources',
    description: 'Content, guides and tools designed for today\'s digital creators.'
  },
  {
    number: '05',
    title: 'Business Resources',
    description: 'Practical digital products for entrepreneurs, freelancers and growing online businesses.'
  },
  {
    number: '06',
    title: 'Instant Digital Access',
    description: 'Get access to your digital purchases according to the delivery details shown on each product.'
  }
];

export const faqs = [
  {
    question: 'What is OrvDigital?',
    answer: 'OrvDigital is a premium digital resources brand built for creators, entrepreneurs and ambitious digital builders. We provide practical digital products including AI resources, templates, creator tools, content collections, guides and business resources.'
  },
  {
    question: 'What kind of digital products do you offer?',
    answer: 'We offer a growing collection of digital products across multiple categories including AI & Digital Bundles, Templates, Creator Resources, Content Collections, Guides & E-books, Courses, Productivity tools, Business & Marketing resources, and Design Resources.'
  },
  {
    question: 'How will I receive my purchase?',
    answer: 'Each product page displays specific delivery information. Generally, you will receive instant digital access to your purchase via email after completing checkout.'
  },
  {
    question: 'Are these physical products?',
    answer: 'No. OrvDigital exclusively sells digital products and resources that are delivered electronically.'
  },
  {
    question: 'How does payment work?',
    answer: 'Payment is processed securely through our checkout system. All transactions are protected and encrypted.'
  },
  {
    question: 'Can I access my purchase on mobile?',
    answer: 'Yes. Digital products can be accessed on any device including desktop, laptop, tablet and mobile.'
  },
  {
    question: 'What should I do if I have trouble accessing a product?',
    answer: 'Please contact our support team through the Contact page and we will assist you promptly.'
  },
  {
    question: 'Can I request a refund?',
    answer: 'Refund eligibility depends on the refund policy displayed for each specific product. Please review the applicable terms before purchasing.'
  }
];

export const trustItems = [
  {
    icon: 'Zap',
    text: 'Instant Digital Access'
  },
  {
    icon: 'CreditCard',
    text: 'One-Time Payment'
  },
  {
    icon: 'Users',
    text: 'Creator-Focused Resources'
  },
  {
    icon: 'Shield',
    text: 'Secure Checkout'
  }
];